<template>
  <Dialog
      :header="title"
      v-model:visible="visible"
      modal
      class="add-trainee-modal"
      :draggable="false"
      :dismissable-mask="true"
      @hide="onHide"
  >
    <div>
      <form ref="formRef" @submit.prevent="addTraineeToGroup">
        <div class="mb-2">
          <label for="add-trainee-reason" class="form-label">{{ t('REASON_REQUIRED_TO_ADD_TO_GROUP') }}</label>
          <Textarea
              id="add-trainee-reason"
              v-model="reason"
              class="w-100"
              :invalid="submitted && !(reason || '').trim()"
              rows="3"
              required
          />
          <small v-if="submitted && !(reason || '').trim()" class="text-danger">{{ t('ERRORS.REASON_IS_REQUIRED') }}</small>
        </div>
      </form>
    </div>

    <template #footer>
      <Button :label="t('CANCEL')" severity="secondary" @click="visible = false"/>
      <Button :label="t('SAVE')" @click="addTraineeToGroup"/>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import {computed, ref} from "vue";
import {injectAxios} from "@/util/inject";
import {useI18n} from "vue-i18n";

const axios = injectAxios();
const {t} = useI18n();

const title = ref("");
const groupId = ref("");
const accountId = ref("");
const reason = ref("");
const submitted = ref(false);

const visible = ref(false);
const formRef = ref<HTMLFormElement | null>(null);

const props = defineProps<{
  id: string;
  afterSave?: () => Promise<any>;
}>();

const openModal = (titleVal: string, groupIdVal: string, accountIdVal: string) => {
  title.value = titleVal;
  groupId.value = groupIdVal;
  accountId.value = accountIdVal;
  reason.value = "";
  submitted.value = false;
  visible.value = true;
};

const reasonState = computed(() => {
  return !submitted.value || (reason.value || "").trim().length > 0;
});

const onHide = () => {
  visible.value = false;
};

const addTraineeToGroup = async function (ev?: Event) {
  if (ev) ev.preventDefault();
  submitted.value = true;

  if (!formRef.value?.checkValidity()) {
    return;
  }

  const requestParams = {
    accountId: accountId.value,
  };

  const requestData = {
    skipAvailabilityValidation: true,
    skipAvailabilityValidationReason: reason.value,
  };

  await axios.post(`/training/group/${groupId.value}/trainee`, requestData, {params: requestParams});

  if (props.afterSave) {
    await props.afterSave();
  }

  visible.value = false;
};

defineExpose({
  openModal,
});
</script>
